import {
  deleteStatusCreator,
  interactionsCreator,
} from "../../../../../../../../stores/thunks/creatorsThunk.tsx";
import { useState } from "react";
import { useAppDispatch } from "../../../../../../../../stores/hooks/hooks.ts";
import { RevButton, RevStatusBadge } from "@revmatics/catalyst";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { faHeart as faHeartLight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFlags } from "launchdarkly-react-client-sdk";

type Props = {
  initLiked: boolean;
  creatorId: number;
};

export const LikeButton = ({ initLiked, creatorId }: Props) => {
  const { likeCreator: ffLikeCreator } = useFlags();
  const dispatch = useAppDispatch();
  const [liked, setLiked] = useState(initLiked);
  const setLike = () => {
    if (creatorId) {
      setLiked(!liked);
      if (liked) {
        dispatch(deleteStatusCreator(creatorId));
      } else {
        dispatch(
          interactionsCreator({ id: creatorId, body: { status: "liked" } }),
        );
      }
    }
  };
  if (ffLikeCreator) {
    return (
      <RevButton
        iconLeft={liked ? faHeart : faHeartLight}
        text={liked ? "Liked" : "Like"}
        variant="primary"
        buttonSize="extraSmall"
        handleClick={setLike}
      />
    );
  }

  return (
    <div className="flex gap-2 items-center justify-center">
      <div className="text-monochrome-600 flex gap-1 items-center">
        <FontAwesomeIcon icon={faHeart} className="text-md" />
        <p className="typography-body-sm">Like Creator </p>
      </div>
      <RevStatusBadge text="Coming Soon" color="info" />
    </div>
  );
};
